import type { AgreementsActivityResult } from '../../activity-handler/agreements-activity.types';
import { fetchGetDwtDefraSubmissionsActivity } from '../api/fetch-get-dwt-defra-submissions-activity';
import type { DwtDefraSubmissionsPayload } from '../models/dwt-defra-submissions.model';

/** Injected collaborators for {@link fetchDwtDefraSubmissionsReport} (composition root / tests). */
export interface DwtDefraSubmissionsReportFetchDeps {
    fetchGetDwtDefraSubmissions(
        accessToken: string,
        payload: DwtDefraSubmissionsPayload
    ): Promise<AgreementsActivityResult>;
}

export const defaultDwtDefraSubmissionsReportFetchDeps: DwtDefraSubmissionsReportFetchDeps = {
    fetchGetDwtDefraSubmissions: fetchGetDwtDefraSubmissionsActivity,
};
